import { render } from "./LineIco.vue?vue&type=template&id=a12f5b22"
import script from "./LineIco.vue?vue&type=script&lang=js"
export * from "./LineIco.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__